/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { TextField, YouTubeUrlField } from '@molecules';
import MediaField from '@organisms/MediaField';
import { Button } from '@atoms';

import { FORM_FIELDS } from './constant';
import Form from '../Form';

const AddVideoForm = ({ onSubmit }) => {
  const [form] = Form.useForm(FORM_FIELDS);

  const handleFinish = React.useCallback(
    (values) => {
      onSubmit(values);
      form.resetFields();
    },
    [form, onSubmit],
  );

  return (
    <Form form={form} onSerializedFinish={handleFinish} layout="vertical">
      <MediaField {...FORM_FIELDS.IMAGE} />
      <TextField {...FORM_FIELDS.TITLE} />
      <YouTubeUrlField {...FORM_FIELDS.LOCATION} />
      <Form.Item>
        <Button type="customBlue" onClick={form.submit}>
          ADD VIDEO
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AddVideoForm;
